import React, { useMemo } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import FAQ from './components/FAQ';
import { fs, s, v } from '../../utils/libs';
import { theme, useLayoutSize } from '../../theme';
import { shouldUseWidthConstraint } from '../../utils/layoutUtils';
import { WEB_MAX_CONTENT_WIDTH } from '../../theme/webLayoutWidths';
const questionList = [
  {
    id: 1,
    title: 'What is BizPlus POS Solution?',
    description:
      'BizPlus POS system is a comprehensive solution that combines point-of-sale (POS) functionality with inventory management and other business tools. It helps businesses manage sales, inventory, and payments interactions efficiently. BizPlus POS is designed to be user-friendly, customizable, and scalable, making it suitable for businesses of all sizes. learn more by visiting https://bizpluspos.co.ke/',
  },
  {
    id: 2,
    title: 'How do I know BizPlus POS is right for my business?',
    description:
      'BizPlus POS is designed for businesses of all sizes, offering a modern, all-in-one solution to handle sales, manage inventory, track transactions, and build customer relationships efficiently. Our intuitive platform helps streamline operations and boost productivity.',
  },
  {
    id: 3,
    title: 'What do I need to get started?',
    description:
      'All you need is a mobile device with internet connection, download the app and you can start selling - We have an easy to use dashboard where you can manage your business and sales, it can be accessed from the app or the web visit https://app.bizpluspos.co.ke/ to login to your dashboard',
  },
  {
    id: 4,
    title: 'How do I get started with BizPlus POS?',
    description:
      'You can start by downloading the BizPlus app on google-play and apple store, then create an account for your business upload your first product and start selling, All this can be done in a span of less than 5 minutes - We also have a dashboard where you can manage your business and sales, it can be accessed from the app or the web',
  },
  {
    id: 5,
    title: 'What is the cost of using BizPlus POS?',
    description:
      'BizPlus POS has a variety of pricing plans ranging from the Free plan to a custom plan, which are all pocket friendly - Every business has its wants, needs and we use that to calculate the pricing. Please visit our Pricing section for more information https://bizpluspos.co.ke/pricing ',
  },
];
export default function FaqScreen() {
  const { width, height } = useLayoutSize();
  const useWidthConstraint = shouldUseWidthConstraint(width, height);
  const styles = useMemo(
    () => createStyles(useWidthConstraint),
    [useWidthConstraint],
  );

  return (
    <View style={styles.safeArea}>
      <ScrollView style={styles.container}>
        <View style={styles.content}>
          <FAQ>
            {questionList.map(question => (
              <FAQ.QAItem id={question.id} key={question.id}>
                <FAQ.Question title={question.title} answerId={question.id} />
                <FAQ.Answer id={question.id}>{question.description}</FAQ.Answer>
              </FAQ.QAItem>
            ))}
          </FAQ>
        </View>
      </ScrollView>
    </View>
  );
}

const createStyles = (useWidthConstraint: boolean) =>
  StyleSheet.create({
    safeArea: {
      flex: 1,
    },
    container: {
      flex: 1,
      backgroundColor: theme.colors.surface,
    },
    content: {
      padding: s(8),
      paddingTop: v(10),
      paddingBottom: v(40),
      ...(useWidthConstraint
        ? {
            maxWidth: WEB_MAX_CONTENT_WIDTH,
            alignSelf: 'center',
            width: '100%',
          }
        : {}),
    },

    subtitle: {
      fontSize: fs(16),
      color: theme.colors.textGray500,
      marginBottom: v(20),
    },
  });
